import React from 'react';

import {Scroll} from '@pb/kit-component-scroll';
import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './menu.module.styl';

import type {ComponentPropsWithoutRef} from 'react';


const classnames = withCssModule(styles);

type Props = ComponentPropsWithoutRef<typeof Scroll>;

/**
 * Default body for FloatingMenu.
 * Supposed to be used inside FloatingMenu.
 * */
export const FloatingMenuBody = ({
    children,
    className,
    ...props
}: Props) => (
    <Scroll
        {...props}
        className={classnames('list', className)}>
        {children}
    </Scroll>
);
